import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import styles from "./Receipt.module.scss";
import BackButton from "../../../components/common/BackButton/BackButton";
import Barcode from "react-barcode";
import { MdStorefront } from "react-icons/md";

const Receipt = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const receiptNumber = "68409258";

    const products = [
        {
            id: 1,
            title: "Smart Watch for girls with flowers",
            variation: "Pink/S/Polyester",
            quantity: 1,
            price: 33.99,
            store: "AS Store",
            delivery: "Delivery within 5-7 business days",
            image: "https://placehold.co/136x126?text=Maelano"
        },
        {
            id: 2,
            title: "Top Shirt for Women with full sleeves",
            variation: "Pink/S/Polyester",
            quantity: 1,
            price: 33.99,
            store: "AS Store",
            delivery: "Delivery within 5-7 business days",
            image: "https://placehold.co/136x126?text=Maelano"
        },
    ];

    const totalDetails = [
        { label: "Products Amount", value: "67.98%" },
        { label: "Shipping Fee", value: "5$" },
        { label: "Shipping Discount", value: "-2$" },
        { label: "Coupon Discount", value: "-8$" },
    ];

    const finalTotal = [
        { label: "Payment Amount", value: "$62.98" },
        { label: "Order date", value: "30 Sep 2024, 1:10 AM" },
    ];

    return (
        <>
            <BackButton />
            <Container fluid className={styles.eReceiptMainContainer}>
                <h3 className={styles.mainHeading}>E-Receipt</h3>
                <Container fluid className={styles.eReceipt}>
                    <Row noGutters>
                        <Col md="12" className={styles.header}>
                            <div className={styles.barcode}>
                                <Barcode
                                    value={receiptNumber}
                                    width={windowWidth > 768 ? 5 : windowWidth > 575 ? 3.5 : 2.5}
                                    height={windowWidth > 575 ? 50 : 40}
                                    displayValue={false}
                                    fontSize={14}
                                    background="#ffffff"
                                    lineColor="#000000"
                                />
                            </div>
                            <h3 className={styles.orderId}>Order ID: 68409258</h3>
                        </Col>
                    </Row>

                    <Row noGutters>
                        <Col md="12" className={styles.orderedProducts}>
                            <h4 className={styles.sectionHeading}>Ordered Products</h4>
                            {products.map((product) => (
                                <Card key={product.id} className={styles.productCard}>
                                    <CardBody className={styles.cardBody}>
                                        <Row noGutters className={styles.productCardRow}>
                                            <Col lg="3">
                                                <div className={styles.imgContainer}>
                                                    <img
                                                        src={product.image}
                                                        alt={product.title}
                                                        className={styles.productImage}
                                                    />
                                                </div>
                                            </Col>
                                            <Col lg="9">
                                                <div className={styles.productDetails}>
                                                    <h4 className={styles.productTitle}>{product.title}</h4>
                                                    <div className={styles.productVariation}>
                                                        {product.variation}
                                                    </div>
                                                    <div className={styles.productQuantity}>
                                                        Qty: {product.quantity}
                                                    </div>
                                                    <div className={styles.productPriceAndStore}>
                                                        <p className={styles.price}>${product.price}</p>
                                                        <div className={styles.store}>
                                                            <MdStorefront size={windowWidth > 575 ? 24 : 20} />
                                                            {product.store}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        <div className={styles.delivery}>
                                            <p>Standard Delivery</p>
                                            <p className={styles.deliveryTime}>
                                                {product.delivery}
                                            </p>
                                        </div>
                                    </CardBody>
                                </Card>
                            ))}
                        </Col>
                    </Row>
                    <Row noGutters>
                        <Col md="12" className={styles.total}>
                            <h4 className={styles.sectionHeading}>Total</h4>
                            <div className={styles.totalDetails}>
                                {totalDetails.map((item, index) => (
                                    <Row noGutters key={`${item.label}-${index}`} className={styles.amountDiscountRow}>
                                        <Col lg={6}>
                                            <p>{item.label}:</p>
                                        </Col>
                                        <Col lg={6}>
                                            <p>{item.value}</p>
                                        </Col>
                                    </Row>
                                ))}
                                {finalTotal.map((item, index) => (
                                    <Row noGutters key={`${item.label}-${index}`} className={styles.finalAmountRow}>
                                        <Col lg={6}>
                                            <p>{item.label}:</p>
                                        </Col>
                                        <Col lg={6}>
                                            <p className={styles.finalValues}>{item.value}</p>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Container fluid className={styles.placeOrderBtnContainer}>
                    <Button
                        color="info"
                        className={styles.orderPlaceBtn}
                    >
                        Download Receipt
                    </Button>
                </Container>
            </Container>
        </>
    );
};

export default Receipt;